<modal
  [id]="modalId()"
  [header]="'v2.orgSettings.billing.addPaymentCardModalTitle'"
  [headerIcon]="headerIcon()"
  [closeButtonEnabled]="true"
  [enableBackdropClose]="!isSaving()"
  [escapeToClose]="!isSaving()"
  [showHeaderDivider]="true"
  [showFooterDivider]="false"
  [heightClass]="'tw-h-fit tw-max-h-[90vh]'"
  [widthClass]="'tw-w-11/12 md:tw-w-3/4 lg:tw-w-[552px] xl:tw-w-xl tw-max-w-xl'"
  (onCloseModal)="close()"
>
  <div slot="body" class="tw-flex tw-flex-col tw-gap-5 tw-pb-2"  [class.tw-max-h-40]="isInitializing()">
   
    <div class="tw-flex tw-flex-col tw-gap-3">
      <div
        class="tw-rounded-xl tw-border tw-border-gray-200 dark:tw-border-gray-700 tw-bg-white dark:tw-bg-gray-800 tw-px-4 tw-pt-6"
        [class.tw-border-red-600]="cardError()"
        [class.tw-opacity-60]="isSaving()"
      >
        @if (isInitializing()) {
          <div class="tw-flex tw-flex-col tw-gap-3 tw-pb-4">
            <ngx-skeleton-loader
              count="1"
              [theme]="{
                width: '100%',
                height: '44px',
                'border-radius': '8px',
                backgroundColor: getSkeletonTheme().backgroundColor,
                color: getSkeletonTheme().color
              }"
              animation="pulse"
            ></ngx-skeleton-loader>
          </div>
        } @else {
          <div #cardElement class="tw-min-h-11"></div>
        }
      </div>

      <p class="tw-font-inter tw-text-sm tw-min-h-5 tw-leading-5 tw-text-red-600" role="alert">
        {{ cardError() }}
      </p>

      @if (isInitializing()) {
        <div class="tw-inline-flex tw-items-center tw-gap-3">
          <ngx-skeleton-loader
            count="1"
            [theme]="{
              width: '16px',
              height: '16px',
              'border-radius': '4px',
              backgroundColor: getSkeletonTheme().backgroundColor,
              color: getSkeletonTheme().color
            }"
            animation="pulse"
          ></ngx-skeleton-loader>
          <ngx-skeleton-loader
            count="1"
            [theme]="{
              width: '220px',
              height: '16px',
              'border-radius': '6px',
              backgroundColor: getSkeletonTheme().backgroundColor,
              color: getSkeletonTheme().color
            }"
            animation="pulse"
          ></ngx-skeleton-loader>
        </div>
      } @else {
        <label
          class="tw-inline-flex tw-items-center tw-gap-3"
          [class.tw-cursor-pointer]="!isSetAsDefaultLocked()"
          [class.tw-cursor-not-allowed]="isSetAsDefaultLocked()"
          [class.tw-opacity-60]="isSetAsDefaultLocked()"
        >
          <input
            type="checkbox"
            class="tw-h-4 tw-w-4 tw-rounded tw-border-gray-300 tw-text-blue-600 focus:tw-ring-blue-500 disabled:tw-cursor-not-allowed"
            [checked]="setAsDefault()"
            [disabled]="isSaving() || isSetAsDefaultLocked()"
            (change)="toggleSetAsDefault($any($event.target).checked)"
          />
          <span class="tw-font-inter tw-text-sm tw-leading-5 tw-text-gray-700 dark:tw-text-gray-300">
            {{ 'v2.orgSettings.billing.setAsDefaultPaymentCard' | translate }}
          </span>
        </label>
      }
    </div>

    @if (isInitializing()) {
      <ngx-skeleton-loader
        count="1"
        [theme]="{
          width: '100%',
          height: '48px',
          'border-radius': '12px',
          backgroundColor: getSkeletonTheme().backgroundColor,
          color: getSkeletonTheme().color
        }"
        animation="pulse"
      ></ngx-skeleton-loader>
    } @else {
      <button
        type="button"
        class="tw-w-full tw-inline-flex tw-items-center tw-justify-center tw-h-12 tw-rounded-xl tw-bg-blue-600 hover:tw-bg-blue-700 disabled:tw-opacity-50 disabled:tw-cursor-not-allowed tw-transition-colors tw-font-inter tw-font-medium tw-text-sm tw-text-white"
        (click)="save()"
        [disabled]="isSaving()"
      >
        @if (isSaving()) {
          {{ 'v2.common.processing' | translate }}
        } @else {
          {{ 'v2.common.save' | translate }}
        }
      </button>
    }
  </div>
</modal>
